import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from "../../context/TranslationContext";

const TermsPage = () => {
    const { translateSync, currentLanguage, setCurrentLanguage } = useTranslation();

    useEffect(() => {
        AOS.init({ duration: 1000, once: false, mirror: true });
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Terms and Conditions | Colours Boutique</title>
                <meta name="description" content="Read the Colours Boutique terms and conditions for online saree shopping, orders, and payments." />
                <link rel="canonical" href="https://coloursboutique.com/terms" />
            </Helmet>

            <div className="home-saree-container">
                <section className="about-header-section text-center" style={{ paddingTop: "150px", paddingBottom: "20px" }}>
                    <div className="container">
                        <h1 className="fw-bold display-5 font-51" style={{ color: "#3a3530" }}>{translateSync('Terms & Conditions')}</h1>
                        <nav aria-label="breadcrumb" className="boutique-breadcrumb-nav center-align">
                            <ol className="boutique-breadcrumb-ol boutique-breadcrumb-center">
                                <li className="breadcrumb-item"><span onClick={() => window.location.href = "/"}>{translateSync('Home')}</span></li>
                                <li className="breadcrumb-item active">{translateSync('Terms & Conditions')}</li>
                            </ol>
                        </nav>
                    </div>
                </section>

                <section className="training-transforms-section py-5 ">
                    <div className="container">
                        <div className="row align-items-stretch">
                            <div className="col-md-12 text-left justify-content-between">
                                <div className="aboutpage-content newww" >
                                    <div className="terms-content" style={{ lineHeight: '1.8' }}>
                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="200">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>1. {translateSync('Acceptance of Terms')}</h3>
                                            <p className="mb-0">
                                                {translateSync('Welcome to Colours Boutique. By accessing our website, browsing our collections, or purchasing our products, you agree to comply with and be bound by these Terms and Conditions.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="300">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>2. {translateSync('Product Descriptions & Handmade Variations')}</h3>
                                            <p className="mb-0">
                                                {translateSync('We specialize in authentic handwoven Indian silk sarees. Because our products are handcrafted by traditional weavers, minor variations in threads, knots, colors, and patterns are natural characteristics of handloom items and are not considered defects.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="400">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>3. {translateSync('Pricing & Payments')}</h3>
                                            <p className="mb-0">
                                                {translateSync('All prices are displayed in the selected currency (SGD / INR) and are subject to change. Payments must be made in full at checkout. We support major card brands and payment methods securely.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="500">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>4. {translateSync('Shipping, Customs & Taxes')}</h3>
                                            <p className="mb-0">
                                                {translateSync('We offer shipping across Singapore and India. Delivery timelines are estimates. Shoppers are responsible for any applicable local customs charges or duties imposed by their respective countries upon importing goods.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="600">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>5. {translateSync('Intellectual Property')}</h3>
                                            <p className="mb-0">
                                                {translateSync('All logo designs, content, images, graphics, and product names on this site are the exclusive intellectual property of Colours Boutique. Unauthorized reproduction, distribution, or commercial use is strictly prohibited.')}
                                            </p>
                                        </div>

                                        <div className="contact-info p-4 rounded-3" style={{ backgroundColor: "#f9f9f9" }} data-aos="fade-up" data-aos-delay="700">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>{translateSync('Contact Colours Boutique')}</h3>
                                            <p className="mb-3">{translateSync('Have a question about our terms or need order support?')}</p>
                                            <ul className="list-unstyled">
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Email')}: <a href="mailto:coloursboutiqueadmin@gmail.com" className="text-decoration-none" style={{ color: "#3a3530" }}>coloursboutiqueadmin@gmail.com</a></span>
                                                </li>
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Phone')}: +91 80562 62626</span>
                                                </li>
                                                <li className="d-flex">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Business Hours')}: Monday – Saturday | 9:00 AM – 6:00 PM</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default TermsPage;